import $ from 'jquery';
import City from 'portlets/site/order/city/city';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaOrderNoDelivery',
			dom: {
				city: '.js-city',
				name: '#yotaOrderNoDeliveryCityName',
				button: '#yotaOrderNoDeliveryButton'
			},
			classes: {
				find: 'b-order-nodelivery_state_find'
			},
			callback: {
				set: false
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = (this.options.el instanceof $) ? this.options.el : $(this.options.el);
		return this;
	}

	getDom() {
		this.$city = this.$el.find(this.options.dom.city);
		this.$name = this.$el.find(this.options.dom.name);
		this.$button = this.$el.find(this.options.dom.button);
		return this;
	}

	setCity(data) {
		this.$el.removeClass(this.options.classes.find);
		this.$name.html(data.name);
		const href = this.$button.data('href')
			.replace('{#code}', data.code)
			.replace('{#center}', data.center)
			.replace('{#id}', data.id)
			.replace('{#map1}', data.map[0])
			.replace('{#map2}', data.map[1]);
		this.$button.attr('href', href);
	}

	onCitySet(data) {
		if (typeof this.options.callback.set == 'function') {
			this.options.callback.set(data, 'nodelivery');
		}
	}

	onCityClear(/* data */) {
		this.$el.removeClass(this.options.classes.find);
	}

	find(event) {
		event.preventDefault();
		this.$el.addClass(this.options.classes.find);
		this.city.focus();
	}

	render() {
		const self = this;
		if (self.$el.length) {
			self.getDom();

			self.city = new City({
				el: self.$city,
				callback: {
					set: self.onCitySet.bind(self),
					clear: self.onCityClear.bind(self)
				}
			}).render();

			self.$name.on('click', self.find.bind(self));
		}
		return self;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/order/nodelivery/nodelivery.js